import { render, staticRenderFns } from "./iframeBaseContent.vue?vue&type=template&id=94d85c00&scoped=true&"
import script from "./iframeBaseContent.vue?vue&type=script&lang=js&"
export * from "./iframeBaseContent.vue?vue&type=script&lang=js&"
import style0 from "./iframeBaseContent.vue?vue&type=style&index=0&id=94d85c00&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d85c00",
  null
  
)

export default component.exports